import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../App";

const LoginPage: React.FC = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const accessToken = urlParams.get("accessToken");
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      login();
      navigate("/", { replace: true });
    }
  }, [login, navigate, location.search]);

  const handleGoogleLogin = () => {
    window.location.href = "https://api.seth-towe.com/auth/google";
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-300">
  <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
    <h1 className="text-2xl font-bold mb-4 text-center">Login</h1>
    <div className="space-y-4">
      <button
        onClick={handleGoogleLogin}
        className="flex items-center justify-center gap-2 bg-white border border-gray-300 shadow-sm px-4 py-2 rounded-full w-full text-black-900 hover:bg-blue-50"
      >
        <img src="/googleLogo.png" 
             alt="Google Logo" 
             className="w-5 h-5" 
        />

        <span>Sign in with Google</span>
      </button>
    </div>
  </div>
</div>

  );
};

export default LoginPage;